import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const EcommerceTagsSelectMultipleTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("array"), optionIs("EcommerceTagsSelect", true))
);

export default EcommerceTagsSelectMultipleTester;
